import { render, staticRenderFns } from "./SvgSymbolList.vue?vue&type=template&id=2985914e&scoped=true"
import script from "./SvgSymbolList.vue?vue&type=script&lang=ts"
export * from "./SvgSymbolList.vue?vue&type=script&lang=ts"
import style0 from "./SvgSymbolList.vue?vue&type=style&index=0&id=2985914e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2985914e",
  null
  
)

export default component.exports